import { UserOrganizationRole } from '@/types/org'

export interface LoginPayload {
  email: string
  password: string
}

export interface User {
  id: number
  name: string
  email: string
  role: string
  avatar?: string
  organization?: {
    id: number
    name: string
    description?: string
  }
  measure?: {
    id: number
    name: string
  }
  timeZone?: string
  gmtTimeZone?: {
    id: number
    zoneId: string
    displayName: string
    offset: {
      ticks: number
      days: number
      hours: number
      milliseconds: number
      minutes: number
      seconds: number
      totalDays: number
      totalHours: number
      totalMilliseconds: number
      totalMinutes: number
      totalSeconds: number
    }
    hour: number
  }
  isAdmin: boolean
  isSuperAdmin: boolean
  isSuperUserOfAnyOrganization: boolean
}

export interface RegisterPayLoad {
  name: string
  email: string
  password: string
  confirmPassword: string
}

export interface ResetPasswordPayload {
  token: string
  email: string
  newPassword: string
  confirmPassword: string
}
export interface ChangePasswordPayload {
  email: string
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export interface ChangeUserProfilePayload {
  measureId?: number
  timeZone?: string
  gmtTimeZoneId?: number
}

/**
 * this is SystemRole
 */
export enum UserRole {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  User = 'User',
}

/**
 * Organization-specific roles
 */
export enum OrganizationRole {
  Manager = 'Manager',
  Member = 'Member',
  ViewOnly = 'ViewOnly',
}

/**
 * Permission levels for interface access
 */
export enum PermissionLevel {
  FULL_ADMIN = 'FULL_ADMIN',
  SUPER_USER = 'SUPER_USER',
  USER = 'USER',
  VIEW_ONLY = 'VIEW_ONLY',
  NO_ACCESS = 'NO_ACCESS',
}

export interface UserOrganization extends User {
  organizations?: UserOrganizationRole[]
}

/**
 * SCRUM-90
 */
export interface UserOrganizationExists {
  organizationId: number
  email: string
}

/**
 * Interface permission metadata
 */
export interface InterfacePermission {
  interfaceId: number
  permissionLevel: PermissionLevel
  canView: boolean
  canEdit: boolean
  canAccessAdmin: boolean
  canManageUsers: boolean
  sharedOrganizations: number[]
  highestRole: OrganizationRole | null
}

/**
 * User with enhanced permission information
 */
export interface UserWithPermissions extends UserOrganization {
  interfacePermissions?: InterfacePermission[]
  globalPermissionLevel?: PermissionLevel
}
